import { render, staticRenderFns } from "./add-exam-final-step.vue?vue&type=template&id=a2904382&scoped=true"
import script from "./add-exam-final-step.vue?vue&type=script&lang=ts"
export * from "./add-exam-final-step.vue?vue&type=script&lang=ts"
import style0 from "./add-exam-final-step.vue?vue&type=style&index=0&id=a2904382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2904382",
  null
  
)

export default component.exports